const DEFAULT_ONLYPAY_EMAILS = new Set([
  'faleconosco@onlypay.com.br',
  'queroajuda@onlypay.com.br',
  'email@email.com',
  'email@email.com.br',
  'nome@email.com.br',
  'teste@teste.com',
  'teste@teste.com.br'
]);

const DEFAULT_ONLYPAY_EMAIL_DOMAINS = new Set([
  'onlypay.com.br',
  'onlypay.com'
]);

export function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

export function isDefaultOnlyPayEmail(value) {
  const email = normalizeEmail(value);
  if (!email || !email.includes('@')) return false;

  if (DEFAULT_ONLYPAY_EMAILS.has(email)) return true;

  const domain = email.split('@').pop();
  return DEFAULT_ONLYPAY_EMAIL_DOMAINS.has(domain);
}
